export default __webpack_public_path__ + "static/media/093-resize-3.928bf077.png";